const toFlag = (raw) => {
  if (raw === true || raw === 1 || raw === '1' || raw === 'true') return true;
  if (raw === false || raw === 0 || raw === '0' || raw === 'false') return false;
  return undefined;
};

const pickFrom = (obj) => {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return undefined;
  return (
    toFlag(obj.isAutoFormationEnabled) ??
    toFlag(obj.autoFormationEnabled) ??
    toFlag(obj.auto_formation_enabled) ??
    toFlag(obj.is_auto_formation_enabled) ??
    (Array.isArray(obj.autoFormation) ? undefined : toFlag(obj.autoFormation)) ??
    toFlag(obj.auto_formation) ??
    toFlag(obj.autopick) ??
    toFlag(obj.autoPick)
  );
};

export const readAutoFormationEnabled = (payload) =>
  pickFrom(payload) ??
  pickFrom(payload?.tactics) ??
  pickFrom(payload?.settings) ??
  pickFrom(payload?.team);
